import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../";

import {
  Alignment,
  Button,
  Classes,
  IButtonProps,
  Text
} from "@blueprintjs/core";

import { IMPDIconProps, Justify, MPDIcon } from "../";

import "./styles.css";

export interface IMPDButtonProps extends IButtonProps, IMPDIconProps {
  text?: string;
  alignIcon?: Alignment;
  justifyIcon?: Justify;
  width?: number;
  height?: number;
}

interface IMPDButtonState {
  align: Alignment;
  justify: Justify;
}

export class MPDButton extends React.Component<
  IMPDButtonProps,
  IMPDButtonState
> {
  constructor(props: IMPDButtonProps) {
    super(props);
    const { alignIcon, justifyIcon } = this.props;
    this.state = {
      align: alignIcon || Alignment.LEFT,
      justify: justifyIcon || Justify.CENTER
    };
  }

  public render() {
    const {
      className,
      itemState,
      name,
      hoverName,
      selectName,
      text,
      tabIndex,
      alignIcon,
      justifyIcon,
      width,
      height,
      ...newProps
    } = this.props;

    const { align, justify } = this.state;

    const classes = classNames(
      myClasses.BUTTON,
      Classes.alignmentClass(align),
      myClasses.justifyClass(justify),
      name !== undefined && text !== undefined && "full-button",
      className
    );

    return (
      <Button
        style={{ height, width }}
        className={classes}
        tabIndex={tabIndex}
        {...newProps}
      >
        {name !== undefined && (
          <MPDIcon
            tabIndex={tabIndex}
            name={name}
            hoverName={hoverName}
            selectName={selectName}
            itemState={itemState}
          />
        )}
        {text !== undefined && (
          <Text className={myClasses.BUTTON_TEXT}> {text} </Text>
        )}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mpd-library/button/button.tsx